import { useMutation } from "react-query";
import api from "../../client";
import {
  UpdatePeoplePayload,
  UpdatePeopleResponseData,
} from "../../types/people";

const putData = async (
  payload: UpdatePeoplePayload,
): Promise<UpdatePeopleResponseData> => {
  const { data } = await api.put<UpdatePeopleResponseData>(`/profile`, payload);

  return data;
};

export const useUpdatePeople = () => {
  return useMutation((payload: UpdatePeoplePayload) => {
    return putData(payload);
  });
};
